/**
 * Maps the app's i18n locale to a reCAPTCHA `hl` (widget language) code.
 *
 * reCAPTCHA accepts most BCP-47 codes as-is (e.g. `en-GB`, `fr`, `de`, `ja`, `es`)
 * and silently auto-detects the browser language for anything it does not recognise —
 * so an unmapped code is never worse than passing nothing (today's behaviour). We only
 * remap codes where reCAPTCHA's expected value differs from ours; currently that is
 * Hebrew, which reCAPTCHA still identifies by the legacy `iw` code rather than `he`.
 *
 * @see https://developers.google.com/recaptcha/docs/language
 */
const APP_LOCALE_TO_RECAPTCHA_HL: Record<string, string> = {
  he: 'iw',
  'he-IL': 'iw',
};

export function toRecaptchaHl(locale: string | undefined): string | undefined {
  if (!locale) {
    return undefined;
  }

  return APP_LOCALE_TO_RECAPTCHA_HL[locale] ?? locale;
}
